import React from "react";
import "./SoftwareSkill.scss";
import {skillsSection} from "../../portfolio";
import {useTranslation} from "react-i18next";

export default function SoftwareSkill() {
  const {t} = useTranslation();

  // Group skills by type
  const groupedSkills = skillsSection.softwareSkills.reduce((acc, skill) => {
    if (!acc[skill.type]) acc[skill.type] = [];
    acc[skill.type].push(skill);
    return acc;
  }, {});

  // Optional: enforce a specific order
  const typeOrder = ["backend", "frontend", "devops", "others"];

  return (
    <div className="software-skills-main-div">
      {typeOrder
        .filter(type => groupedSkills[type]) // only render existing categories
        .map(type => (
          <div key={type} className="skill-card">
            <h3
              className="skill-card-title"
              style={{textTransform: "capitalize"}}
            >
              {" "}
              {t(`skills.types.${type}`, type)}
            </h3>
            <ul className="dev-icons">
              {groupedSkills[type].map((skill, i) => (
                <li
                  key={i}
                  className="software-skill-inline"
                  name={skill.skillName}
                >
                  <i className={skill.devIconClassName}></i>
                  <p>{skill.skillName}</p>
                </li>
              ))}
            </ul>
          </div>
        ))}
    </div>
  );
}
